export const colorsTab50 = [
  "#ff0000",
  "#0000f0",
  "#00ef00",
  "#00bfef",
  "#6f0050",
  "#605f00",
  "#40f0af",
  "#1f6fef",
  "#efe000",
  "#efafaf",
  "#f01fe0",
  "#002f3f",
  "#800f00",
  "#ef9030",
  "#eff0a0",
  "#ef006f",
  "#008f00",
  "#df90f0",
  "#00006f",
  "#207f5f",
  "#7f80b0",
  "#b0f0e0",
  "#401f10",
  "#b0ef5f",
  "#8030cf",
  "#f06f60",
  "#202f6f",
  "#7f7060",
  "#cf5f90",
  "#2ff06f",
  "#80af60",
  "#bf0090",
  "#a09f00",
  "#cfd0f0",
  "#a05f2f",
  "#80409f",
  "#2f808f",
  "#105f0f",
  "#203f1f",
  "#cf0030",
  "#7f4050",
  "#9f1040",
  "#dfaf70",
  "#00c0c0",
  "#2f102f",
  "#0090e0",
  "#df5010",
  "#c0bf9f",
  "#908ff0",
  "#f0c03f"
];

